export const BUDGET_STATE = "BUDGET_STATE";
export const CHANGE_BUDGET_START_DATE = "CHANGE_BUDGET_START_DATE";
export const CHANGE_BUDGET_END_DATE = "CHANGE_BUDGET_END_DATE";
export const CHANGE_BUDGET_DATA = "CHANGE_BUDGET_DATA";
export const GET_TRANSACTIONS_STARTED = "GET_TRANSACTIONS_STARTED";
export const GET_TRANSACTIONS_SUCCEEDED = "GET_TRANSACTIONS_SUCCEEDED";
export const GET_TRANSACTIONS_FAILED = "GET_TRANSACTIONS_FAILED";
export const SHOW_CREATE_MODAL = "SHOW_CREATE_MODAL";
export const HIDE_CREATE_MODAL = "HIDE_CREATE_MODAL";


